import script from "./AnnotationToolSequenceRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationToolSequenceRibbon.vue?vue&type=script&setup=true&lang=js"

import "./AnnotationToolSequenceRibbon.vue?vue&type=style&index=0&id=06582a09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06582a09"]])

export default __exports__